import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ClickToCallModal from './ClickToCallModal'
import { RENTAL_CAR_CLICK_TO_CALL_NO_RESULTS } from 'commons/js/constants'
import { RentalCarEvents, trackTealiumEvent } from 'commons/js/services/analytics'

const NoResultsModal = ({ onClose }) => {
  const onModalLoaded = () => {
      trackTealiumEvent(RentalCarEvents.eventSearchWithNoResults)
    }
    const handleSuccessPhoneNumberCall = () => {
      trackTealiumEvent(RentalCarEvents.showC2cPhoneSentFromNoResults)
      trackTealiumEvent(RentalCarEvents.eventC2cPhoneSentFromNoResults)
    }

  useEffect(() => {
      trackTealiumEvent(RentalCarEvents.showSearchWithNoResults)
    }, [])
    return <ClickToCallModal
      isShown
      onClose={onClose}
      modalType={RENTAL_CAR_CLICK_TO_CALL_NO_RESULTS}
      onShowPrivacyModal={onClose}
      zIndex={999999}
      showExtraC2CInfo
      onLoad={onModalLoaded}
      onSuccessPhoneNumberCallSent={handleSuccessPhoneNumberCall}
    />
}

NoResultsModal.propTypes = {
    onClose: PropTypes.func,
}

export default NoResultsModal
